// CST207: static imports of all namespace JSON files, keyed by language.
// Consumed by i18n/config.ts at init. Type augmentation is deferred until Step 8
// (populated namespaces) per plan — empty stubs would collapse `typeof resources`
// to `{}` and silently disable key autocomplete.
import deCommon from "./locales/de/common.json";
import deErrors from "./locales/de/errors.json";
import deMarketing from "./locales/de/marketing.json";
import deAuth from "./locales/de/auth.json";
import deSearch from "./locales/de/search.json";
import deResults from "./locales/de/results.json";
import deIcp from "./locales/de/icp.json";
import deCredits from "./locales/de/credits.json";
import deSettings from "./locales/de/settings.json";
import deOnboarding from "./locales/de/onboarding.json";
import deMembers from "./locales/de/members.json";
import deAdmin from "./locales/de/admin.json";

import enCommon from "./locales/en/common.json";
import enErrors from "./locales/en/errors.json";
import enMarketing from "./locales/en/marketing.json";
import enAuth from "./locales/en/auth.json";
import enSearch from "./locales/en/search.json";
import enResults from "./locales/en/results.json";
import enIcp from "./locales/en/icp.json";
import enCredits from "./locales/en/credits.json";
import enSettings from "./locales/en/settings.json";
import enOnboarding from "./locales/en/onboarding.json";
import enMembers from "./locales/en/members.json";
import enAdmin from "./locales/en/admin.json";

export const resources = {
  de: {
    common: deCommon,
    errors: deErrors,
    marketing: deMarketing,
    auth: deAuth,
    search: deSearch,
    results: deResults,
    icp: deIcp,
    credits: deCredits,
    settings: deSettings,
    onboarding: deOnboarding,
    members: deMembers,
    admin: deAdmin,
  },
  en: {
    common: enCommon,
    errors: enErrors,
    marketing: enMarketing,
    auth: enAuth,
    search: enSearch,
    results: enResults,
    icp: enIcp,
    credits: enCredits,
    settings: enSettings,
    onboarding: enOnboarding,
    members: enMembers,
    admin: enAdmin,
  },
} as const;
